import React, { useEffect } from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const About = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-brand-dark min-h-screen text-white">
      <SEO 
        title="About Us - Christian Videos"
        description="Learn more about Christian Videos, our mission to share inspirational Christian content worldwide."
        url="https://christianvideos.in/about"
      />
      {/* Back Button */}
      <div className="p-4 sm:p-6 flex items-center gap-4">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 hover:text-gray-300 transition-colors text-sm sm:text-base"
        >
          <FiArrowLeft size={20} className="sm:w-6 sm:h-6" />
          <span>Back</span>
        </button>
      </div>

      {/* Content */}
      <div className="px-4 sm:px-6 md:px-8 lg:pl-20 lg:pr-8 py-8 sm:py-12 max-w-4xl">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-gradient-accent">
          About Christian Videos
        </h1>

        <div className="space-y-6 text-gray-300">
          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">Our Mission</h2>
            <p>
              Christian Videos is dedicated to bringing inspirational Christian content to viewers worldwide. 
              Our platform provides a curated collection of sermons, messages, songs, and teachings from 
              renowned preachers and Christian leaders.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">What We Offer</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <strong>Diverse Content:</strong> From powerful sermons to uplifting Christian songs in multiple languages
              </li>
              <li>
                <strong>Featured Preachers:</strong> Content from renowned spiritual leaders including Rev. Johnson V, 
                M A Varughese, TD Jakes, Steven Furtick, and more
              </li>
              <li>
                <strong>Multi-Language Support:</strong> Content available in Tamil, Malayalam, English, and other languages
              </li>
              <li>
                <strong>Easy Navigation:</strong> Search, browse by category, and create personalized watchlists
              </li>
              <li>
                <strong>Responsive Design:</strong> Seamless viewing experience across desktop, tablet, and mobile devices
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">Our Content Categories</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-gray-800 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Featured Preachers</h3>
                <p className="text-sm text-gray-400">Rev. Johnson V, M A Varughese, TD Jakes, Steven Furtick, and more</p>
              </div>
              <div className="bg-gray-800 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Christian Songs</h3>
                <p className="text-sm text-gray-400">Tamil Songs, Malayalam Songs, English Songs, and more</p>
              </div>
              <div className="bg-gray-800 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">New Videos</h3>
                <p className="text-sm text-gray-400">Latest sermons and messages added regularly</p>
              </div>
              <div className="bg-gray-800 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Personal Watchlist</h3>
                <p className="text-sm text-gray-400">Save your favorite videos for later viewing</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">Why Choose Christian Videos?</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Free access to quality Christian content</li>
              <li>High-quality streaming with YouTube integration</li>
              <li>Easy search and discovery of spiritual content</li>
              <li>Voice search capability for hands-free navigation</li>
              <li>Share your favorite videos with friends and family</li>
              <li>Analytics tracking to enhance your experience</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">Viewing Experience</h2>
            <p>
              Our platform is designed to provide an intuitive and engaging viewing experience. Whether you're 
              on a desktop, tablet, or mobile device, Christian Videos adapts to your screen size and provides 
              consistent, high-quality content playback.
            </p>
          </section>

          <section className="bg-gray-800 p-6 rounded-lg">
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">Get Started Today</h2>
            <p>
              Explore our collection of Christian content, discover new preachers and messages, and build your 
              personal watchlist. Join thousands of viewers worldwide who trust Christian Videos for their daily 
              spiritual inspiration.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
